// MUST match functions-pdfparser/security.js (MAX_FILES, MAX_BYTES).
// Keep in sync manually until these are merged into a shared package.
export const PARSER_CAPS = {
  maxFiles: 5,
  maxBytes: 25 * 1024 * 1024,
};
